import React from "react";
import { addDays, format, isSameDay, isSameMonth, isToday } from "date-fns";
import { ru } from "date-fns/locale";

export const itemColor = (it) => (it.overdue ? "#EF4444" : it.kind === "deadline" ? "#FB923C" : "#FACC15");
const WEEKDAYS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
const itemsOn = (items, day) => items.filter((it) => isSameDay(new Date(it.start), day));

function Chip({ it, onItem }) {
  const c = itemColor(it);
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); onItem(it); }} title={it.title} data-testid={`calendar-item-${it.id}`}
      className="w-full text-left text-[11px] truncate rounded px-1.5 py-0.5 border" style={{ color: c, borderColor: `${c}66`, background: `${c}14` }}>
      {format(new Date(it.start), "HH:mm")} {it.title}
    </button>
  );
}

export function MonthView({ from, date, items, onDay, onItem }) {
  const days = Array.from({ length: 42 }, (_, i) => addDays(from, i)).filter((d, i) => i < 35 || isSameMonth(d, date));
  return (
    <div data-testid="calendar-month-view">
      <div className="grid grid-cols-7 gap-1 mb-1">{WEEKDAYS.map((w) => <div key={w} className="text-xs text-gray-500 text-center">{w}</div>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {days.map((d) => {
          const list = itemsOn(items, d);
          return (
            <div key={d.toISOString()} onClick={() => onDay(d)} data-testid={`calendar-day-${format(d, "yyyy-MM-dd")}`}
              className={`min-h-[92px] rounded-lg p-1.5 cursor-pointer border transition-colors hover:border-[#D4AF37]/50 ${isSameMonth(d, date) ? "border-white/5 bg-white/[0.02]" : "border-transparent opacity-40"}`}>
              <div className={`text-xs mb-1 w-5 h-5 flex items-center justify-center rounded-full ${isToday(d) ? "bg-[#D4AF37] text-black font-bold" : "text-gray-400"}`}>{format(d, "d")}</div>
              <div className="space-y-0.5">
                {list.slice(0, 3).map((it) => <Chip key={it.id} it={it} onItem={onItem} />)}
                {list.length > 3 && <div className="text-[10px] text-gray-500">+{list.length - 3}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function WeekView({ from, items, onDay, onItem }) {
  const days = Array.from({ length: 7 }, (_, i) => addDays(from, i));
  return (
    <div className="grid grid-cols-1 sm:grid-cols-7 gap-2" data-testid="calendar-week-view">
      {days.map((d) => (
        <div key={d.toISOString()} className="rounded-lg border border-white/5 bg-white/[0.02] p-2 min-h-[220px]">
          <button type="button" onClick={() => onDay(d)} className={`text-xs mb-2 ${isToday(d) ? "text-gold font-bold" : "text-gray-400"}`}>
            {format(d, "EEEEEE, d MMM", { locale: ru })}
          </button>
          <div className="space-y-1">{itemsOn(items, d).map((it) => <Chip key={it.id} it={it} onItem={onItem} />)}</div>
        </div>
      ))}
    </div>
  );
}

export function DayView({ date, items, onItem }) {
  const list = itemsOn(items, date);
  return (
    <div className="space-y-2" data-testid="calendar-day-view">
      {list.length === 0 && <p className="text-gray-400">На этот день ничего нет.</p>}
      {list.map((it) => (
        <button key={it.id} type="button" onClick={() => onItem(it)} className="w-full text-left glass-cyan rounded-xl p-4 flex gap-4 items-start" data-testid={`calendar-day-item-${it.id}`}>
          <span className="font-mono text-sm" style={{ color: itemColor(it) }}>{format(new Date(it.start), "HH:mm")}</span>
          <div className="min-w-0">
            <div className="font-medium">{it.title}</div>
            <div className="text-xs text-gray-400">{it.kind === "deadline" ? (it.overdue ? "🔴 Просроченный дедлайн" : "🟠 Дедлайн заказа") : "🟡 Личное событие"}</div>
            {it.notes && <div className="text-sm text-gray-300 mt-1 whitespace-pre-line line-clamp-3">{it.notes}</div>}
          </div>
        </button>
      ))}
    </div>
  );
}
